


import moment from 'moment'

export function monthsPeriod(months, lang) {

  var length = months.length;
  var minLength = 12;
  var selectedStart = 1;
  var selectedEnd = 12;

  for (var first = -11; first <= 12; first++) {
    for (var last = 1; last <= 12; last++) {
      var monthsInPeriod = 0;

      months.forEach(function(month){

        if (first < 0) {

        }

        if ((month >= first && month <= last) || ((month-12 >= first) && (month-12 <= last))) {
          monthsInPeriod++;
        }
      });

      if (monthsInPeriod == length && last-first < minLength) {


        minLength = last-first;
        selectedStart = (first>0)?first:first+12;
        selectedEnd = last;
      }

    }
  }


  moment.locale(lang);
  return [moment([0, selectedStart-1, 2]).format('MMMM'), moment([0, selectedEnd-1, 2]).format('MMMM')];
}



// WEBPACK FOOTER //
// ./src/common/api/monthsPeriod.js